import { Box, Typography } from '@mui/material';
import { DISPLAY, tokens } from '../theme';

export interface Stat {
  value: string;
  label: string;
  /** Chỉ tô màu khi con số mang ý nghĩa tốt/xấu, còn lại để màu mực. */
  color?: string;
}

/**
 * Dải số tổng quan — khối `\.stats` của demo: các ô trắng cách nhau bằng đường 1px
 * chứ không phải thẻ rời có bóng, nên đọc như một bảng số liệu liền mạch.
 */
export function StatStrip({ items }: { items: Stat[] }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr 1fr', md: `repeat(${items.length}, 1fr)` },
        gap: '1px',
        bgcolor: tokens.line,
        border: `1px solid ${tokens.line}`,
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      {items.map((it) => (
        <Box key={it.label} sx={{ bgcolor: '#fff', px: 2.1, py: 1.9 }}>
          <Typography
            sx={{ fontFamily: DISPLAY, fontSize: 23, fontWeight: 700, color: it.color ?? tokens.ink }}
          >
            {it.value}
          </Typography>
          <Typography sx={{ fontSize: 13, color: 'text.secondary', mt: 0.3 }}>{it.label}</Typography>
        </Box>
      ))}
    </Box>
  );
}
